"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConvertHeat = void 0;
const StandardActionCard_1 = require("../../StandardActionCard");
const CardName_1 = require("../../../CardName");
const CardRenderer_1 = require("../../render/CardRenderer");
const PartyHooks_1 = require("../../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../../turmoil/parties/PartyName");
const constants_1 = require("../../../constants");
const Card_1 = require("../../Card");
const RedsPolicy_1 = require("../../../turmoil/RedsPolicy");
class ConvertHeat extends StandardActionCard_1.StandardActionCard {
    constructor() {
        super({
            name: CardName_1.CardName.CONVERT_HEAT,
            tr: { temperature: 1 },
            metadata: {
                cardNumber: 'SA2',
                renderData: CardRenderer_1.CardRenderer.builder((b) => b.standardProject('Spend 8 Heat to raise temperature 1 step.', (eb) => {
                    eb.heat(8).startAction.temperature(1);
                })),
            },
        });
    }
    canAct(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this, false, 'take this action');
        if (player.game.getTemperature() === constants_1.MAX_TEMPERATURE) {
            Card_1.Card.setUselessActionWarningText(this, 'temperature is already maxed');
        }
        if (player.availableHeat < constants_1.HEAT_FOR_TEMPERATURE)
            return false;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            const bonusMegaCredits = player.cardIsInEffect(CardName_1.CardName.SUITABLE_INFRASTRUCTURE) && player.willGainHeatProductionFromTemperatureIncrease(1) ? 2 : 0;
            const actionDetails = new RedsPolicy_1.ActionDetails({ temperatureIncrease: 1, reservedHeat: constants_1.HEAT_FOR_TEMPERATURE, bonusMegaCredits: bonusMegaCredits });
            const howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails);
            return howToAffordReds.canAfford;
        }
        return true;
    }
    action(player) {
        return player.spendHeat(constants_1.HEAT_FOR_TEMPERATURE, () => {
            this.actionUsed(player);
            player.game.increaseTemperature(player, 1);
            return undefined;
        });
    }
}
exports.ConvertHeat = ConvertHeat;
//# sourceMappingURL=ConvertHeat.js.map